/*
auth0-provider-with-navigate.js
Adam Berger
July 2023

cf: https://developer.auth0.com/resources/guides/spa/react/basic-authentication
*/

// 3P imports
import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { Auth0Provider } from "@auth0/auth0-react";
// 1P imports 
import * as Constants from "components/Constants";


export const Auth0ProviderWithNavigate = ({ children }) => {
  const navigate = useNavigate();

  const domain = Constants.AUTH0_DOMAIN;
  const clientId = Constants.AUTH0_CLIENT_ID;
  const redirectUri = Constants.AUTH0_CALLBACK_URI;
  const audience = Constants.AUTH0_AUDIENCE;

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId && redirectUri && audience)) {
    console.log("Missing one of: domain, clientID, redirectUri, audience")
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: audience,
        redirect_uri: redirectUri,
        response_type: 'token id_token',
        scope: 'openid profile email offline_access'
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      tokenCache={{
        cacheLocation: "localstorage",
        store: {
          getItem: (key) => localStorage.getItem(key),
          setItem: (key, value) => localStorage.setItem(key, value),
          removeItem: (key) => localStorage.removeItem(key)
        }
      }}
    >
      {children}
    </Auth0Provider>
  );
};

Auth0ProviderWithNavigate.propTypes = {
  children: PropTypes.node.isRequired,
};